import Services from '../../services'
import {splitIdsCollection} from "../../utils/store";
import {asyncForEach} from "../../utils/array";
import hash from 'object-hash';

const state = {
  assets: {},
  assetsIds: [],
  assetsAliases: {},
  criteria: {},
  criteriaIds: [],
  sectors: {},
  sectorsIds: [],
  filtersHash: {},
};

// getters
const getters = {
  asset: (state) => aliasOrId => {
    return state.assets[aliasOrId] || state.assets[state.assetsAliases[aliasOrId]];
  },
  assetsByFilter: (state) => filter => {
    let filterHash = hash(filter);

    return Object.keys(state.assets)
      .filter(key => state.filtersHash[filterHash].includes(key))
      .reduce((obj, key) => {
        obj[key] = state.assets[key];
        return obj;
      }, {});
  },
  getByIds: (state, getters) => ids => {
    return state.assets.filter(a => ids.includes(a.id));
  },
  getById: (state, getters) => id => {
    return state.assets.find(a => a.id === id);
  },
  getAll: (state, getters) => state.assets,
  criterion: (state) => id => {
    return state.criteria[id];
  },
  criteria: (state) => state.criteria,
  sector: (state) => id => {
    return state.sectors[id];
  }
};

// actions
const actions = {
  async fetchAsset({commit, state, dispatch, rootGetters}, aliasOrId) {
    console.log('fefe fetchAsset', state )
    if(state.assets[aliasOrId] || state.assets[state.assetsAliases[aliasOrId]]) {
      return;
    }

    dispatch('wait/start', 'assets.fetchAsset', {root: true});
    dispatch('wait/start', `assets.${aliasOrId}.fetch`, {root: true});
    const data = await Services.Assets.fetchAsset(aliasOrId);
    await dispatch('pushAsset', data);
    dispatch('wait/end', `assets.${aliasOrId}.fetch`, {root: true});
    dispatch('wait/end', 'assets.fetchAsset', {root: true});
  },

  async fetchAssets({commit, state, dispatch, rootGetters}, ids) {
    ids = _.isArray(ids) ? ids : [ids];

    if(_.difference(ids, state.assetsIds).length > 0) {
      dispatch('wait/start', 'assets.fetchAssets', {root: true});
      const data = await Services.Assets.fetchAssets(_.difference(ids, state.assetsIds));
      await dispatch('pushAssets', data);
      dispatch('wait/end', 'assets.fetchAssets', {root: true});
    }
  },

  async fetchAssetsByFilter({commit, state, dispatch, rootGetters}, filter) {
    const filterHash = hash(filter);

    if(!state.filtersHash[filterHash]) {
      dispatch('wait/start', 'assets.fetchAssets', {root: true});
      const data = await Services.Assets.fetchAssetsByFilter(filter);
      await dispatch('saveFilter', {
        data,
        hash: filterHash,
        cb(data) {
          return data.map(a => a.id);
        }
      });
      await dispatch('pushAssets', data);
      dispatch('wait/end', 'assets.fetchAssets', {root: true});
    }
  },

  async pushAssets({commit, state, dispatch}, assets) {
    await asyncForEach(assets, async a => dispatch('pushAsset', a));
  },

  async pushAsset({commit, state, dispatch}, asset) {
    if(state.assets[asset.id]) {
      return;
    }

    const prepareAsset = asset;
    const { ids: sectorsIds, objects: sectorsObjects } = splitIdsCollection(prepareAsset.sectors);
    const { ids: criteriaIds, objects: criteriaObjects } = splitIdsCollection(prepareAsset.criteria.map(c => c.criterion));

    await dispatch('pushSectors', sectorsObjects);
    await dispatch('pushCriteria', criteriaObjects);

    // assemble true collection of criteria with popularity property
    const assembledCriteria = {};

    prepareAsset.criteria.forEach(c => {
      if(criteriaIds.includes(c.criterion)) {
        assembledCriteria[c.criterion] = c;
      } else if(criteriaObjects.includes(c.criterion)) {
        assembledCriteria[c.criterion.id] = {
          criterion: c.criterion.id,
          popularity: c.popularity
        };
      }
    });

    prepareAsset.sectors = sectorsIds.concat(sectorsObjects.map(s => s.id));

    // console.log(prepareAsset.sectors);

    prepareAsset.criteria = assembledCriteria;

    commit('addAsset', {id: prepareAsset.id, asset: prepareAsset});
  },

  async fetchAssetsCriteria({commit, state, dispatch}, assets) {
    await dispatch('fetchCriteria', _.uniq(
        ...assets.map(
          a => _.toArray(
            _.mapValues(
              a.criteria, c => c.criterion)
          )
        )
      )
    );
  },

  async fetchAssetCriteria({commit, state, dispatch}, asset) {
    await dispatch('fetchCriteria', _.toArray(_.mapValues(asset.criteria, c => c.criterion)));
  },

  async searchCriteria({commit, state, dispatch, rootGetters}, search) {
    // const searchHash = hash(search);

    // if(state.filtersHash[searchHash]) {
    //   return;
    // }
    if(search === '') {
      return;
    }

    dispatch('wait/start', 'assets.searchCriteria', {root: true});
    const criteria = await Services.Assets.searchCriteria(search, rootGetters['auth/token']);
    await dispatch('pushCriteria', criteria);

    // dispatch('saveFilter', {
    //   data: criteria,
    //   hash: searchHash,
    // });

    dispatch('wait/end', 'assets.searchCriteria', {root: true});
  },

  async fetchCriteria({commit, state, dispatch}, ids) {
    await asyncForEach(ids, async id => await dispatch('fetchCriterion', id));
  },

  async fetchCriterion({commit, state, dispatch, rootGetters}, id) {
    if(!state.criteria[id]) {
      const data = await Services.Assets.fetchCriterion(id, rootGetters['auth/token']);
      await dispatch('pushCriterion', data);
    }
  },

  async fetchSectors({commit, state, dispatch}, ids) {
    dispatch('wait/start', 'assets.fetchSectors', {root: true});
    await asyncForEach(ids, async id => await dispatch('fetchSector', id));
    dispatch('wait/end', 'assets.fetchSectors', {root: true});
  },

  async fetchSector({commit, state, dispatch, rootGetters}, id) {
    // if(!state.sectors[id]) {
      const data = await Services.Assets.fetchSector(id, rootGetters['auth/token']);
      dispatch('pushSector', data);

      return data;
    // }
  },

  async pushCriteria({commit, state, dispatch}, criteria) {
    await asyncForEach(criteria, async a => await dispatch('pushCriterion', a));
  },

  async pushCriterion({commit, state, dispatch}, criterion) {
    if(!state.criteria[criterion.id]) {
      commit('addCriterion', {id: criterion.id, criterion});
    }
  },

  async pushSectors({commit, state, dispatch}, sectors) {
    await asyncForEach(sectors, a => dispatch('pushSector', a));
  },

  async pushSector({commit, state, dispatch}, sector) {
    if(!state.sectors[sector.id]) {
      commit('addSector', {id: sector.id, sector});
    }
  },

  async saveFilter({commit, state, dispatch}, {data, hash, cb = null}) {
    commit('addFilter', {id: hash, data: typeof cb === 'function' ? cb(data) : {}});
  }
};

// mutations
const mutations = {
  addCriterion(state, {id, criterion}) {
    state.criteria[id] = criterion;
  },

  addSector(state, {id, sector}) {
    state.sectors[id] = sector;
  },

  addAsset(state, {id, asset}) {
    state.assets[id] = asset;
    if(asset.alias) {
      state.assetsAliases[asset.alias] = id;
    }
  },

  addFilter(state, {id, data}) {
    state.filtersHash[id] = data;
  },

  addCriterionToAsset(state, {assetId, criterionId}) {
    console.log(assetId);
    console.log(state.assets[assetId]);
    state.assets[assetId].criteria[criterionId] = {
      criterion: criterionId,
      popularity: 0
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assets.js